(function($) {

$(document).ready(function(){
	$('.lm-slider__controls__left').on('click',function(){
		var slider 	= $(this).closest('.lm-slider');
		var current = parseInt(slider.attr('current'));
		if (current > 0) {
			current--;
			updateSlider(slider,current);
		}
	});
	$('.lm-slider__controls__right').on('click',function(){
		var slider 	= $(this).closest('.lm-slider');
		var current = parseInt(slider.attr('current'));
		if (current < slider.find('.slide').length-1) {
			current++;
			updateSlider(slider,current);
		}
	});
	function updateSlider(slider,current) {
		slider.attr('current',current);
		slider.find('.slide').css('left','-'+current+'00%');
		slider.find('.lm-slider__pagination span').removeClass('active').eq(current).addClass('active');
	}
});

})( jQuery );  